import React, { useState, useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useHistory } from "react-router-dom";
import { USER_NOTIFICATION_ROUTES } from "route";
import { requestForToken, onMessageListener } from "./firebase";

const Notification = () => {
  const [notification, setNotification] = useState({ title: "", body: "" });
  const [data, setData] = useState({});
  const notify = () => toast(<ToastDisplay />);

  const history = useHistory();

  const onNotificationClick = () => {
    console.log("Notification onNotificationClick", notification);
    const category = data.category;

    let url = process.env.PUBLIC_URL;
    if (category) {
      url = `${process.env.PUBLIC_URL}/${USER_NOTIFICATION_ROUTES[category]}?id=${data.contentId}`;
    }
    history.push(url);
  };

  function ToastDisplay() {
    return (
      <div onClick={onNotificationClick}>
        <p className="mb-1 text-primary cursor-pointer">
          <b>{notification?.title} </b>
          <i className="fa fa-arrow-up"></i>
        </p>
        <p className="mb-0">{notification?.body}</p>
      </div>
    );
  }

  useEffect(() => {
    if (notification?.title) {
      notify();
    }
  }, [notification]);

  onMessageListener()
    .then((payload) => {
      console.log("Notification onNotificationClick payload", payload);
      setData(payload.data || {});
      setNotification({
        title: payload?.notification?.title,
        body: payload?.notification?.body,
      });
    })
    .catch((err) => console.log("failed: ", err));

  return <Toaster toastOptions={{ duration: 3000 }} position="top-right" />;
};

export default Notification;
